import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { commonStyle } from './getSelectorStyle'

export const Radio: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      control: {
        ...commonStyle(props),
        borderRadius: 'full',
      },
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
